import * as React from "react";
import { forwardRef } from "react";
const SvgTheme = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12Zm10 7.5v-15a7.5 7.5 0 0 0 0 15Z", clipRule: "evenodd" }));
const ForwardRef = forwardRef(SvgTheme);
export default ForwardRef;
